import React from "react";
import ImageSection from "./ImageSection/ImageSection";

// images
import { images } from "./img";

// Utility to calculate experience
const calculateYearsOfExperience = () => {
  const startDate = new Date("2017-02-01");
  const now = new Date();
  const diffInMs = now.getTime() - startDate.getTime();
  const diffInYears = diffInMs / (1000 * 60 * 60 * 24 * 365.25);
  return Math.floor(diffInYears);
};

// Shuffle utility
const getRandomUniqueImages = (arr, count) => {
  const shuffled = [...arr].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

const About = () => {
  const yearsOfExperience = calculateYearsOfExperience();
  const selectedImages = getRandomUniqueImages(images, 2);
  return (
    <div className="section" id="about">
      <div className="container">
        <div className="col-md-6">
          <h4>01</h4>
          <h1 className="size-50">About me</h1>
          <div className="h-50"></div>

          <p>
            I'm a Fullstack Engineer and Engineering Manager with {yearsOfExperience}+ years of experience building and scaling web and mobile applications. My technical foundation spans JavaScript/TypeScript, Java and a wide range of frameworks including Angular, React, Node.js, Spring Boot and React Native. I’ve contributed across the stack - from hands-on feature development to designing scalable architectures and implementing automated testing pipelines.
          </p>

          <p>
            Over the years, I’ve grown into leadership roles, mentoring engineers, leading code quality initiatives and aligning engineering practices with business outcomes. Most recently, I transitioned into an Engineering Manager role where I still stay deeply technical - driving quality, process and team performance at Scrums.com.
          </p>

          <p>
            I'm passionate about clean, maintainable code, scalable systems and helping people grow. I thrive in fast-moving, high-impact environments and I’m drawn to opportunities where strong technical culture and collaboration go hand in hand.
          </p>

          <div className="h-50"></div>
          <div className="h-50"></div>
        </div>

        {selectedImages.map((imgPath, i) => (
          <ImageSection key={i} imgPath={imgPath} />
        ))}
      </div>
    </div>
  );
};

export default About;
